import { HttpParams, HttpResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tc } from '../../../core/_infrastructure/types/common';
import {
    FilterSearchingPermisosAccionesImpresosIyIIIViewModel,
    PermisosAccionesImpresosIyIIIViewModel,
    PermisosAccionesImpresosIyIIIItemResultsViewModel,
} from './permisosaccionesimpresosIyIII.types';

@Injectable()
export class PermisosAccionesImpresosIyIIIService {
    permisosAccionesImpresosIyIIIEndpoint = this.baseUrl + 'api/mantenimiento/permisosaccionesimpresosiyiii/';
    private lastSearch?: FilterSearchingPermisosAccionesImpresosIyIIIViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    private convertModelToHttpParms(payload: FilterSearchingPermisosAccionesImpresosIyIIIViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingPermisosAccionesImpresosIyIIIViewModel;

        for (k in payload) {
            let v;
            let valor = payload[k];
            if (k == 'Edicion' && valor == 0) {
                v = 0;
            } else {
                v = payload[k] || '';
            }

            params = params.append(k, v);
        }

        return params;
    }

    getPermisosAccionesImpresosIyIII(
        payload: FilterSearchingPermisosAccionesImpresosIyIIIViewModel,
    ): Observable<PermisosAccionesImpresosIyIIIItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getPermisosAccionesImpresosIyIIIPagedByFilter(params);
    }

    getPermisosAccionesImpresosIyIIIPagedByFilter(params: HttpParams): Observable<PermisosAccionesImpresosIyIIIItemResultsViewModel> {
        return this.http.get<PermisosAccionesImpresosIyIIIItemResultsViewModel>(this.permisosAccionesImpresosIyIIIEndpoint + 'pagedbyfilter/', {
            params: params,
        });
    }

    getPermisoAccionImpresosIyIII(id: number): Observable<PermisosAccionesImpresosIyIIIViewModel> {
        return this.http.get<PermisosAccionesImpresosIyIIIViewModel>(this.permisosAccionesImpresosIyIIIEndpoint + id);
    }

    getAcciones(idModulo: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.permisosAccionesImpresosIyIIIEndpoint + 'acciones/' + idModulo);
    }

    getPerfiles(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.permisosAccionesImpresosIyIIIEndpoint + 'perfiles');
    }

    getEstadosImpresosIyIII(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.permisosAccionesImpresosIyIIIEndpoint + 'estadosimpresosiyiii');
    }

    savePermisoAccionImpresosIyIII(permisoAccionImpreso: PermisosAccionesImpresosIyIIIViewModel): Observable<any> {
        return this.createPermisoAccionImpresosIyIII(permisoAccionImpreso);
    }

    createPermisoAccionImpresosIyIII(permisoAccionImpreso: PermisosAccionesImpresosIyIIIViewModel): Observable<any> {
        return this.http.post<PermisosAccionesImpresosIyIIIViewModel>(this.permisosAccionesImpresosIyIIIEndpoint, permisoAccionImpreso);
    }

    deletePermisoAccionImpresosIyIII(id: number): Observable<any> {
        return this.http.delete<PermisosAccionesImpresosIyIIIViewModel>(this.permisosAccionesImpresosIyIIIEndpoint + id);
    }

    export(model: FilterSearchingPermisosAccionesImpresosIyIIIViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.permisosAccionesImpresosIyIIIEndpoint + 'postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingPermisosAccionesImpresosIyIIIViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }
}
